
import { ChangeProjectionService } from '@analysis/domain';
import { ListRoisResponse, type RoiRepository, type RoiChangesRepository } from '../../ports';
import { ListSampleRoisPayload } from '../../ports/mosaic-roi-query.port';

export class ListRoisForLabelUseCase {
  constructor(private readonly rois: RoiRepository, private readonly changes: RoiChangesRepository) { }

  public async execute(payload: ListSampleRoisPayload): Promise<ListRoisResponse> {
    const result = await this.rois.listWithLabelInSampleForAnalyst(payload);

    const pendingChanges = await this.changes.getForSampleAndAnalyst(payload.sampleId, payload.creatorId);

    if (pendingChanges.length === 0) return result;

    const baselineMap = new Map(result.items.map((r) => [r.id, r]));

    const idsToFetch = pendingChanges
      .filter(
        (c) =>
          !c.isNew &&
          (c.labelsAdded.includes(payload.label) || c.labelsRemoved.includes(payload.label)) &&
          !baselineMap.has(c.id)
      )
      .map((c) => c.id);

    if (idsToFetch.length > 0) {
      const fetched = await this.rois.batchGetByIds(idsToFetch);
      for (const roi of fetched.values()) {
        baselineMap.set(roi.id, roi);
      }
    }

    const projected = ChangeProjectionService.projectChanges(baselineMap, pendingChanges);

    const items = Array.from(projected.values()).filter((r) => r.labels.has(payload.label) || r.labels.size === 0);

    return { items, nextToken: result.nextToken };
  }
}
